import * as XLSX from 'xlsx';

export function parseExcelFile(file, columnMappings, defaults) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        // Read the file data
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        
        // Get the first sheet (or specify sheet name)
        const sheetName = workbook.SheetNames[0]; // You can change this to specific sheet name
        const worksheet = workbook.Sheets[sheetName];
        
        // Convert sheet to JSON
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { raw: false });

        // Map the data
        const mappedData = jsonData.map(row => {
          const mappedRow = {};
          
          Object.keys(row).forEach(key => {
            const trimmedKey = key.trim();
            const mappedKey = columnMappings[key] || columnMappings[trimmedKey];
            
            if (mappedKey) {
              mappedRow[mappedKey] = row[key];
            }
          });
          
          return mappedRow;
        }).filter(row => Object.keys(row).length > 0); // Filter out empty rows

        let finalizedData = mappedData;

        if (defaults && Object.keys(defaults).length > 0) {
            finalizedData = finalizedData.map(row => ({
                ...row,
                ...defaults
            }));
        }
        
        resolve(finalizedData);
      } catch (error) {
        reject(error);
      }
    };
    
    reader.onerror = (error) => reject(error);
    reader.readAsArrayBuffer(file);
  });
}
